// jQuery and Bootstrap are added as tags on _layout.twig because I couldn't get Bootstrap to work through includes

import { runSwiper } from "components/swiper-slideshow.js";
import { runSwiperFeature } from "components/swiper-feature.js";
// import { navigationToggle } from "components/nav.js";
import { navigationToggle } from "components/nav-two.js";
import skipLinks from "components/skipLinks";
import calloutToggle from "components/calloutToggle";
import runFancybox from "./components/fancybox";
import interstitialEmail from "./components/interstitialEmail";
import interstitialExhibition from "./components/interstitialExhibition";
import jumpBarScroll from "./components/jumpBarScroll";
import hideEvents from "./components/hideEvents";
import mailchimp from "./components/mailchimp";

$(document).ready(function () {
  runFancybox();
  runSwiper();
  runSwiperFeature();
  skipLinks();
  navigationToggle();
  calloutToggle();
  interstitialEmail();
  interstitialExhibition();
  jumpBarScroll();
  hideEvents();
  mailchimp("#mc-embedded-subscribe-form-footer");
});
